import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=cea4721a"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=cea4721a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports